import { Box, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { ReactNode } from 'react'

import defaultOrgLogo from '../../../assets/icons/placeholder-logo.svg'
import { useDateTimeFmt } from '../../hooks'

import classes from './OpportunityOptionResult.module.scss'
import { Avatar } from '@percent/lemonade'

type OpportunityOptionResultProps = {
  id: string
  actionBtn?: ReactNode
  img?: string | null
  name: string
  endDate?: string
  prefix?: ReactNode
  handleClick?: VoidFunction
}

export function OpportunityOptionResult({
  id,
  img,
  name,
  endDate,
  actionBtn,
  prefix,
  handleClick
}: Readonly<OpportunityOptionResultProps>) {
  const { t } = useTranslation()
  const { formatDate } = useDateTimeFmt()

  return (
    <Box
      className={classes.Wrapper}
      style={{ cursor: handleClick ? 'pointer' : 'default' }}
      data-testid={`optionResult-${id}`}
      onClick={() => handleClick?.()}
    >
      {prefix ? <Box>{prefix}</Box> : null}
      <Avatar image={img || defaultOrgLogo} alt={name} size="medium" backgroundSizeMode="cover" shape="oval" />
      <Box className={classes.Content}>
        <Text>{name}</Text>
        {endDate ? (
          <Text>
            {t('workplace_giving.volunteering.activityForm.opportunityEndedDate', {
              endDate: formatDate(new Date(endDate))
            })}
          </Text>
        ) : null}
      </Box>
      {actionBtn ? <Box className={classes.Actions}>{actionBtn}</Box> : null}
    </Box>
  )
}
